<template>
  <!-- <div class="viainfo_wrap mt30"> -->
  <div class="viainfo_wrap">
  <!-- <div class="content"> -->
    <!-- <s-location viainfo title="증표정보"/> -->

    <div class="home_navi" style="text-align: center">
      <font>증표정보</font>
    </div>

    <div class="p_top" style="position: absolute;">
      <span class="top_no">발급번호 : {{ sitem.prtno || '미리보기' }}</span>
      <!-- <span class="top_date">발급일시 : {{ sitem.prtdt | moment("YYYY.MM.DD HH:mm") }}</span> -->
    </div>
    <h3 class="p_tit">경유확인서</h3>
    <div style="float: right;">
      <img :src="'/front/api/public/qrCode/' + sitem.qrcode" />
    </div>
    <dl class="b">
      <dt>증표종류 </dt><dd>: {{ sitem.caseclsfnm }} </dd>
      <dt>증표번호 </dt><dd>: {{ sitem.rcptno_print }}</dd>
      <dt class="w3">회원명</dt>
      <dd>
        :
        {{ sitem.a_membnm }}
        <!-- <span v-for="(item,i) in selectCustList" :key="'memb_'+i">{{ item }}</span> -->
        <!-- <span v-for="(item,i) in selectCustList" :key="'memb_'+i">
          <template v-if="i>0">,</template>
          {{ item.membnm }}({{ item.membno }})
        </span> -->
      </dd>
      <template v-if="sitem.freeclsf == 'B10940'">
        <dt>복대리인 </dt><dd>: {{ sitem.bok_dp_name }}</dd>
      </template>
    </dl>

    <div class="p_cont">
      <p> &nbsp; &nbsp; 본회는 변호사법 제29조(변호인선임서 등의 지방변호사회 경유)에 따라 위 회원이<br/>
        아래 사건에 대한 소송위임장(변호인 선임서 포함)을 본회에 경유하였음을 확인합니다.
      </p>
      <p class="al_c">-아래-</p>

      <dl>
        <dt>관할기관 </dt><dd>: {{ sitem.isttoutplac }}</dd>
        <dt>사건유형 </dt><dd>: {{ sitem.casetypenm }} {{ sitem.simgeupnm }}</dd>
        <dt>사건번호 </dt><dd>: {{ sitem.caseno }}</dd>
        <dt class="w3">사건명 </dt><dd>: {{ sitem.casenm }}</dd>
        <dt class="w3">위임인 </dt><dd>: {{ sitem.clientclsf }} {{ sitem.client }}</dd>
        <dt class="w3">상대방 </dt><dd>: {{ sitem.otherside }}</dd>
      </dl>
      <p class="al_c ft_date">{{ new Date() | moment("YYYY.M.D.") }}</p>
      <p class="stamp"><img src="/images/common/report_stamp.png"></p>
      <p class="lh12"> 위 확인서를 법원, 수사기관, 기타 공공기관에 제출한 후에 재출력, 복사, 수정하여 재사용한 경우에는 형법 제 231조(사문서등의 위조·변조),제 234조(위조사문서등의 행사)에 따라 처벌받을 수 있습니다. 또한 위 확인서는 서울지방변호사회 수임사건 경유업무 시스템(https://via.seoulbar.or.kr)에서 진위여부를 조회할 수 있으니 참고하시기 바랍니다.
      </p>
    </div>



</div>
</template>

<style>
/* @import '../../assets/css/main.css'; */
body {font: 16px  맑은 고딕,Dotum,Gulim,Arial; color:#000;}
h1, h2, h3, h4 { font-family:  맑은 고딕,Dotum,Gulim,Arial; color:000;}
.viainfo_wrap { padding:50px;  line-height: 2.2;  color:000; width:750px; margin:0 auto;}
/* .center {  text-align: center; width:100%; margin:0 auto; display: inline-block; position: absolute;} */
.b { font-weight: 900;}

.p_top .top_no{ float: left; }
.p_top .top_center{text-align: center}
.p_top .top_date{ float: right; }


.p_tit { margin:40px 0; text-align: center}
.p_cont p{ margin:40px auto;}
.ft_date { font-size:22px; font-weight:bold}
.stamp { text-align: center}

dl dt { float: left; }
dl dt.w3 { letter-spacing: 8px;;}
dl dd { padding-left:75px;}
dl dd span { display: inline-block; margin-right:5px;}
p.lh12 { line-height:1.7}

@media screen and (max-width:640px){
  .viainfo_wrap { width:100%; padding:20px; box-sizing: border-box}
  .stamp img {width:80%; }

  .p_top .top_date{ float: none ;  display: inline-block; width:100%; }

}
</style>

<script>
let ui
export default {
  data () {
    return {
      report : '', // 레포트 URL
      print_mode : false, // 레포트 출력모드여부 ( 이거 true가 되면 폼을 감춘다 )
      sitem : {},
      sitem_init : {
        viaregdt       : '',
        viaseq         : 0,
        selldt         : '',
        viaplac        : '',
        viafee         : 0,
        caseclsf       : '',
        casetype       : '',
        sellyn         : 'N',  // 판매여부
        statclsf       : '',
        cancelclsf     : '',
        canceldt       : '',
        simgeup        : '',
        simgeup_etc    : '',
        isttoutplac    : '',
        caseno         : '',
        casenm         : '',
        client         : '',
        otherside      : '',
        cntchargdt     : '',
        remk           : '',
        remk2          : '',
        rcptno         : '',
        rcptnoto       : '',
        agntpersnm     : '',
        agntpersprn    : '',
        viadt          : '',
        clientclsf     : '',
        etccase        : '',
        continuyn      : '',
        linkyn         : '',
        lawyernm       : '',
        freemembno     : '',
        sellregdt      : '',
        sellseq        : 0,
        selldtlsseq    : 0,
        attachid       : '', // 첨부파일 ID
      },
      code : {}, // 코드
      sCust : null,
      selectCustList : [],
      loginInfo : {},
      modalName: "c증표사용수정_" + T.randomAZ(10),
      chkList : [],
      modal_title : '',
    }
  },
  created() {
    ui = this.$ui;
    // ui.codeLoad("B20000,B10000,B10100,B10200,B10300,B10400,B10500,B10600,B10700,B10800,B10900,BC0000,B40000,B60000,B10102,B11200,BG0000", code => {
    //   this.code = code
    // });
    this.getData()
  },
  mounted() {
    if (this.$route.query.noalert != '1')
      ui.alert("소송위임장(변호인선임서)에 첨부된 경유확인서와 검색된 경유확인서의<br/> 사건 내역이 일치하는지 확인하시기 바랍니다.<br/> - 발급번호, 증표종류, 증표번호, 사건명, 위임인, 상대방 등 ","안내")
  },
  methods: {
    getData() {
      let api, params, path = this.$route.params.data

      if (path == 'detail') { // 메인에서 조회 성공한 경우
        api = "/public/proc/N_VIAINFO_SEARCH_MAIN"
        params = {
           ...this.$route.query, // rcptno1, rcptno2, membno, client
           mode : "DETAIL"
        }
      } else { // qr코드로 조회
        api = "/public/proc/N_VIAINFO_SEARCH_QRCODE"
        params = { qrcode: path }
      }

      // ------------------------------------------------------------------------------------
      // 1. 증표 상세 데이터 조회
      // ------------------------------------------------------------------------------------
      ui.httpGetDetail(api, params, ret => {

        let tmp = ret.data.rs1[0]

        tmp.selldt     = tmp.selldt     && this.$moment(tmp.selldt).format("YYYY-MM-DD")
        tmp.cntchargdt = tmp.cntchargdt && this.$moment(tmp.cntchargdt).format("YYYY-MM-DD")
        tmp.viadt      = tmp.viadt      && this.$moment(tmp.viadt).format("YYYY-MM-DD") // 사용일 있으면 YYYY-MM-DD 형식으로 출력

        // 증표번호 잘라서 표시
        tmp.rcptno1   = T.left (tmp.rcptno, 5)
        tmp.rcptno2   = T.right(tmp.rcptno, 6)

        // 사임/취하구분 없을 경우 공란(B40100) 기본 선택
        tmp.cancelclsf = tmp.cancelclsf || 'B40100'

        if (!T.isEmpty(tmp.isttoutplac)) {
          // [관할기관] 코드에 해당하는 값이 없으면 [직접입력]으로 보임
          // let check_inc = this.code.BG0000.filter(e => e.text == tmp.isttoutplac)

          // if (check_inc.length == 0) { // isttoutplac의 값이 [관할기관] 코드에 일치 하는 것이 없다
          //   if (T.isEmpty(tmp.prtno)) {
          //     tmp.isttoutplac_etc = tmp.isttoutplac
          //     tmp.isttoutplac = 'etc'
          //   }
          // }
        }
        this.sitem = tmp

        // 담당변호사 목록
        // let tmpList = ret.data.rs2

        // // 사임/취하일자 문자열 포멧
        // tmpList.forEach(e => e.canceldt = e.canceldt && this.$moment(e.canceldt).format("YYYY-MM-DD") )

        // this.selectCustList = tmpList
        // this.sitem.lawyercnt = this.selectCustList.length


      })


    }
  },
}


</script>
<style>

</style>